import axios from 'axios';
import { api, headers } from '../../app/conf';

export const postComment = (ticket_id, comment, token) =>
    axios({
        method: 'post',
        url: `${api}/tickets/${ticket_id}/comments`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/tickets`
        },
        data: comment
    });
